import { storage, db, database, firebase, auth } from "../firebase"

export default{
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async getClasesVehiculos(){
      return await new Promise(async (resolve, reject) =>{
        try {
          let ref = firebase.database().ref("vehiclesClasses")
          ref.once('value')
            .then((snapshot) => {
              let clases = snapshot.val()
              for (let id in clases) clases[id].key = id
              return resolve({
                resultado: 1,
                msj: 'OK',
                clases: clases
              })
            })
            .catch((error) => {
              return resolve({
                resultado: 0,
                msj: error.message
              })
            })
        } catch (error) {
          resolve({
            resultado: 0,
            message: "Ocurrió un problema al ejecutar el método getClasesVehiculos: " + error.message
          })
        }
      })
    },
    async getVehiculos(){
      return await new Promise(async (resolve, reject) =>{
        try {
          let ref = firebase.database().ref("flota")
          ref.once('value')
            .then((snapshot) => {
              let vehiculos = snapshot.val()
              for (let id in vehiculos) vehiculos[id].key = id
              return resolve({
                resultado: 1,
                msj: 'OK',
                vehiculos: vehiculos
              })
            })
            .catch((error) => {
              return resolve({
                resultado: 0,
                msj: error.message
              })
            })
        } catch (error) {
          resolve({
            resultado: 0,
            message: "Ocurrió un problema al ejecutar el método getVehiculos: " + error.message
          })
        }
      })
    }
  }
}